var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloudBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 42.75C13.6616 42.75 10.8197 41.624 8.72427 39.6197C6.62887 37.6154 5.45169 34.897 5.45169 32.0625C5.45169 29.228 6.62887 26.5096 8.72427 24.5053C10.8197 22.501 13.6616 21.375 16.625 21.375C17.3249 18.257 19.3723 15.517 22.3169 13.7577C23.7749 12.8866 25.4093 12.2824 27.1267 11.9798C28.8441 11.6771 30.611 11.6819 32.3264 11.9937C34.0418 12.3056 35.6721 12.9186 37.1243 13.7975C38.5765 14.6765 39.8221 15.8042 40.79 17.1165C41.758 18.4287 42.4292 19.8996 42.7655 21.4453C43.1018 22.991 43.0965 24.5811 42.75 26.125H45.125C47.3296 26.125 49.4439 27.0008 51.0028 28.5597C52.5617 30.1186 53.4375 32.2329 53.4375 34.4375C53.4375 36.6421 52.5617 38.7564 51.0028 40.3153C49.4439 41.8742 47.3296 42.75 45.125 42.75H16.625Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudBlue);
export default __webpack_public_path__ + "static/media/Icon_Cloud_Blue.cd75a1ded030d1934924a39c57d5e93d.svg";
export { ForwardRef as ReactComponent };